import { createAsyncThunk } from '@reduxjs/toolkit';
import { educationService } from 'services';
import {
  EducationStatusError,
  EducationStatusRequest,
  EducationStatusResponse,
  EducationApprovalRegisterRequest,
  EducationApprovalRegister,
  ThunkAPI,
} from 'types';

export const educationStatusList = createAsyncThunk<
  EducationStatusResponse,
  EducationStatusRequest,
  ThunkAPI<EducationStatusError>
>('educationStatus/thunk/educationStatusList', async (data, { rejectWithValue }) => {
  try {
    const { data: educationStatusList } = await educationService.educationStatusList(data);
    return educationStatusList;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const educationApprovalRegister = createAsyncThunk<
  undefined,
  EducationApprovalRegisterRequest,
  ThunkAPI<EducationApprovalRegister>
>('educationStatus/thunk/educationApprovalRegister', async (data, { rejectWithValue }) => {
  try {
    const { data: educationApprovalRegister } = await educationService.educationApprovalRegister(
      data
    );
    return educationApprovalRegister;
  } catch (error) {
    return rejectWithValue(error);
  }
});
